import { Navigate } from "react-router-dom";
import { useAnyPermission } from "../../hooks/usePermission";
import type { Permission } from "../../lib/permissions";

interface RequireAnyPermissionRouteProps {
  permissions: Permission[];
  children: React.ReactNode;
  /** Where to send users who hold none of them. Defaults to the dashboard. */
  redirectTo?: string;
}

/**
 * Route-level guard for a route the server gates with anyOf(...): renders children
 * if the user holds ANY of `permissions` (owner/admin bypass), otherwise redirects.
 *
 * The single-permission guard cannot express this. The day-close report is reachable
 * with either sessions:view or reports:view — a cashier holds the first and not the
 * second — so gating the page on one of them would hide it from half the people the
 * server lets through. UX only; the server still enforces.
 */
export function RequireAnyPermissionRoute({
  permissions,
  children,
  redirectTo = "/dashboard",
}: RequireAnyPermissionRouteProps) {
  const allowed = useAnyPermission(permissions);
  if (!allowed) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
